__turbopack_context__.v({
  "analystRatingHorizontalBarsWrapper": "AnalystRatingBar-module-scss-module__LVyo2W__analystRatingHorizontalBarsWrapper",
  "analystRatingVerticalBarsWrapper": "AnalystRatingBar-module-scss-module__LVyo2W__analystRatingVerticalBarsWrapper",
  "container": "AnalystRatingBar-module-scss-module__LVyo2W__container",
});
